import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

export const spreadsheetDataStateSelector = (state: AppState) => state.spreadsheet.spreadsheetData;

const spreadsheetDataDataSelector = (state: AppState) => state.spreadsheet.spreadsheetData.data;
export const useSpreadsheetDataDataSelector = () => useSelector(spreadsheetDataDataSelector);

const spreadsheetDataLastVersionsSelector = (state: AppState) => state.spreadsheet.spreadsheetData.lastVersions;
export const useSpreadsheetDataLastVersionsSelector = () => useSelector(spreadsheetDataLastVersionsSelector);
